<template>
  <transition name="fade">
    <v-col cols="12" class="pa-0">
      <component
        :is="componentSegment[currentDisplay]"
        :handleSelectOption="handleSelectOption"
        :handleBack="handleBackOptions"
        :liveVideoId="videoId"
        :customVideoId="videoId"
        :isExternalSourceVideo="isExternalSourceVideo"
        :hasEdit="hasEdit"
        :storedFunnelId="storedFunnelId"
        @showFooter="handleShowFooter"
      />
    </v-col>
  </transition>
</template>

<script>
import VideoPlayerOptions from './VideoPlayerOptions.vue'
import VideoPlayerSubtitles from './VideoPlayerSubtitles.vue'
import VideoPlayerSubtitlesV1 from './VideoPlayerSubtitlesV1.vue'
import VideoPlayerDubbing from './VideoPlayerDubbing.vue'
import VideoPlayerThumbnails from './VideoPlayerThumbnails.vue'
import VideoPlayerColors from './VideoPlayerColors.vue'
import VideoPlayerControls from './VideoPlayerControls.vue'
import VideoPlayerAutoplay from './VideoPlayerAutoplay.vue'
import VideoPlayerChapters from './VideoPlayerChapters.vue'
import VideoPlayerAlternativeProgress from './VideoPlayerAlternativeProgress.vue'
import VideoPlayerPreviewThumbs from './VideoPlayerPreviewThumbs.vue'
import VideoPlayerSaveProgress from './VideoPlayerSaveProgress.vue'
import VideoPlayerFacebookPixel from './VideoPlayerFacebookPixel.vue'
import VideoPlayerButtons from './VideoPlayerButtons.vue'
import VideoPlayerQuality from './VideoPlayerQuality.vue'
import VideoPlayerAffiliate from './VideoPlayerAffiliate.vue'
import VideoPlayerPIP from './VideoPlayerPIP.vue'
import VideoPlayerBigPlayButton from './VideoPlayerBigPlayButton.vue'
import VideoPlayerMiniTrigger from './VideoPlayerMiniTrigger.vue'
import VideoPlayerPixels from './VideoPlayerPixels.vue'
import VideoPlayerDRMSecurity from './VideoPlayerDRMSecurity.vue'
import VideoPlayerMindMap from './videoPlayerOptionsAI/VideoPlayerMindMap.vue'
import VideoPlayerQuiz from './videoPlayerOptionsAI/VideoPlayerQuiz.vue'
import VideoPlayerEbook from './videoPlayerOptionsAI/VideoPlayerEbook.vue'
import VideoPlayerSpeed from './VideoPlayerSpeed.vue'
import VideoPlayerOffline from './VideoPlayerOffline.vue'
import VideoPlayerAssistAi from './videoPlayerOptionsAI/VideoPlayerAssistAi.vue'
import VideoPlayerQuizCta from './VideoPlayerQuizCta/VideoPlayerQuizCta.vue'
import VideoPlayerForm from './VideoPlayerForm.vue'
import VideoPlayerButtonInteraction from './VideoPlayerButtonInteraction.vue'
export default {
  name: 'VideoPlayer',
  props: {
    videoId: {
      type: String,
    },
    isExternalSourceVideo: {
      type: Boolean,
      default: false,
    },
    handlePlayerSelection: {
      type: Function,
      default: () => {},
    },
    oldPlayerSelection: {
      type: String,
      default: 'options',
    },
    hasEdit: {
      type: Array,
      defult: [],
    },
    storedFunnelId: {
      type: String,
      default: null,
    },
  },
  components: {
    VideoPlayerPIP,
    VideoPlayerAffiliate,
    VideoPlayerOptions,
    VideoPlayerSubtitlesV1,
    VideoPlayerSubtitles,
    VideoPlayerDubbing,
    VideoPlayerThumbnails,
    VideoPlayerColors,
    VideoPlayerBigPlayButton,
    VideoPlayerControls,
    VideoPlayerAutoplay,
    VideoPlayerChapters,
    VideoPlayerAlternativeProgress,
    VideoPlayerPreviewThumbs,
    VideoPlayerSaveProgress,
    VideoPlayerFacebookPixel,
    VideoPlayerQuality,
    VideoPlayerButtons,
    VideoPlayerMiniTrigger,
    VideoPlayerPixels,
    VideoPlayerDRMSecurity,
    VideoPlayerMindMap,
    VideoPlayerQuiz,
    VideoPlayerEbook,
    VideoPlayerSpeed,
    VideoPlayerOffline,
    VideoPlayerAssistAi,
    VideoPlayerQuizCta,
    VideoPlayerForm,
    VideoPlayerButtonInteraction,
  },
  data: () => ({
    currentDisplay: 'options',
  }),
  mounted() {
    this.handleSelectOption(this.oldPlayerSelection)
    this.updateDisplayFromRoute()
  },
  watch: {
    '$route.name': {
      handler() {
        this.updateDisplayFromRoute()
      },
      immediate: true,
    },
  },
  computed: {
    componentSegment() {
      return {
        options: 'VideoPlayerOptions',
        minitrigger: 'VideoPlayerMiniTrigger',
        subtitlesV1: 'VideoPlayerSubtitlesV1',
        subtitles: 'VideoPlayerSubtitles',
        dubbing: 'VideoPlayerDubbing',
        thumbnails: 'VideoPlayerThumbnails',
        colors: 'VideoPlayerColors',
        controls: 'VideoPlayerControls',
        chapters: 'VideoPlayerChapters',
        autoplay: 'VideoPlayerAutoplay',
        alternativeProgress: 'VideoPlayerAlternativeProgress',
        offlineVideo: 'VideoPlayerOffline',
        showPreviewThumbs: 'VideoPlayerPreviewThumbs',
        saveProgress: 'VideoPlayerSaveProgress',
        facebookPixel: 'VideoPlayerFacebookPixel',
        affiliate: 'VideoPlayerAffiliate',
        pip: 'VideoPlayerPIP',
        buttons: 'VideoPlayerButtons',
        quality: 'VideoPlayerQuality',
        bigPlayButton: 'VideoPlayerBigPlayButton',
        pixels: 'VideoPlayerPixels',
        drmSecurity: 'VideoPlayerDRMSecurity',
        summary: 'VideoPlayerSummary',
        mindMap: 'VideoPlayerMindMap',
        quiz: 'VideoPlayerQuiz',
        ebook: 'VideoPlayerEbook',
        speed: 'VideoPlayerSpeed',
        assistAi: 'VideoPlayerAssistAi',
        question: 'VideoPlayerQuizCta',
        forms: 'VideoPlayerForm',
        buttonInteraction: 'VideoPlayerButtonInteraction',
      }
    },
    playerNamePages() {
      return {
        offlineVideo: 'offlineVideo',
        colors: 'colors',
        controls: 'controls',
        chapters: 'chapters',
        speed: 'speed',
        drmSecurity: 'drmSecurity',
        showPreviewThumbs: 'showPreviewThumbs',
        saveProgress: 'saveProgress',
        autoplay: 'autoplay',
        subtitles: 'subtitles',
        alternativeProgress: 'alternativeProgress',
        bigPlayButton: 'bigPlayButton',
        quiz: 'VideoPlayerQuiz',
        question: 'question',
        forms: 'forms',
        buttonInteraction: 'buttonInteraction',
        buttons: 'buttons',
      }
    },
  },
  methods: {
    handleSelectOption(option) {
      const interactionOptions = ['button', 'question', 'lead']

      if (interactionOptions.includes(option)) {
        this.handleAddInteractionToTimeline(option)
        return
      }

      this.handlePageActionsFooter(option)
      this.currentDisplay = option
      this.handlePlayerSelection(option)
      this.hasEdit?.pop()
    },
    handleAddInteractionToTimeline(optionKey) {
      const typeMapping = {
        button: 'button',
        question: 'quiz',
        lead: 'form',
      }

      const item = {
        type: typeMapping[optionKey] || optionKey,
        data: {},
      }

      this.$root.$emit('addInteractionToTimeline', item)
    },
    handleBackOptions() {
      const closeBtn = document.querySelector(
        '.v-snack--active .v-snack__action button'
      )
      if (closeBtn) closeBtn.click()
      this.handleSelectOption('options')
    },
    handleShowFooter(value) {
      this.$emit('showFooter', value)
    },
    handlePageActionsFooter(option) {
      if (option === 'options') return

      if (this.playerNamePages[option]) this.$emit('showFooter', true)
    },
    updateDisplayFromRoute() {
      const routeToDisplayMap = {
        VideoPageQuizCta: 'question',
        VideoPageButton: 'buttons',
        VideoPageButtonInteraction: 'buttonInteraction',
        VideoPageForm: 'forms',
        VideoPageInfoBar: 'infobar',
        VideoPageChapters: 'chapters',
        VideoPageMiniTrigger: 'minitrigger',
      }

      const routeName = this.$route.name
      if (routeToDisplayMap[routeName]) {
        this.currentDisplay = routeToDisplayMap[routeName]
        this.handlePageActionsFooter(this.currentDisplay)
        this.handlePlayerSelection(this.currentDisplay)
      } else if (routeName === 'VideoPage') {
        this.currentDisplay = 'options'
        this.handlePlayerSelection('options')
      }
    },
  },
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
